// Unable to import properly from '~/styles' (results in undefined variables), using relative import until fixed

import { css } from '@emotion/react';

import {
  darkGrey,
  greyBackground,
  pinkishOrange,
  standardBorder,
  steelGrey,
} from '../styled-variables';

export const lightComponent = css`
  background-color: ${greyBackground};
  color: ${steelGrey};
`;

// darkGrey import is for some reason not working?
export const darkComponent = css`
  background-color: ${darkGrey};
  background-color: #26292d;
  color: #fff;
`;

export const cardComponent = css`
  background: #fff;
  border: solid 0.5px rgba(197, 209, 215, 0.5);
  border-radius: 2px;
  overflow: hidden;
`;

export const filterCheckbox = css`
  input[type='checkbox'] + label::before {
    border: ${standardBorder};
    border-radius: 4px;
    content: '\00a0';
    display: inline-block;
    font: 16px/1em sans-serif;
    height: 18px;
    width: 18px;
    margin: 2px 11px 0 0;
    padding: 0;
    vertical-align: top;
  }

  input[type='checkbox'] {
    visibility: hidden;
    position: absolute;
  }

  label {
    cursor: pointer;
  }

  input[type='checkbox']:checked + label::before {
    background-color: ${pinkishOrange};
    border-color: ${pinkishOrange};
    color: #333;
    content: '';
    background-image: url('../../assets/fonts/icons/icon-checkmark.svg');
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
  }

  input[type='checkbox']:checked + label::after {
    font-weight: bold;
  }

  input[type='checkbox']:focus + label::before {
    outline: rgb(59, 153, 252) auto 5px;
  }
`;
